import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap, faCheck, faLayerGroup } from '@fortawesome/free-solid-svg-icons'
import FrontHeader from '../components/FrontHeader'
import FrontFooter from '../components/FrontFooter'

import HeroSection from '../components/HeroSection';
import DashboardBanner from '../components/DashboardBanner';
import CryptoWiget from '../components/CryptoWiget';
import CryptoJourney from '../components/CryptoJourney';
import SectionBody from '../components/SectionBody';
import ProductsSection from '../components/ProductsSection';
import DownloadApp from '../components/DownloadApp';

function Home() {
  return (
    <div>
      {/*<div style={{position: 'relative'}}>
        <FrontHeader/>
         <div className="container position-relative" style={{zIndex: '12', paddingBottom: '8rem', paddingTop: '8rem'}}>
          <h1 className="text-center text-white fw-bold mb-4 font-large" style={{lineHeight: '1.1'}}>Revolutionizing your digital <br/> trading experience</h1>
          <p className="mb-5 mx-auto text-center" style={{maxWidth: '40rem'}}>Seamlessly merging complexity with ease, Altoracapital offers top-notch security, 24/7 support, and an intuitive platform for your tenacious trading and investment needs.</p>
          <div className="d-flex align-items-center justify-content-center">
            <Link to="/register" className="myBtn bg-prime px-3 py-2-5 rounded-pill">Get started</Link>
            <Link to="/login" className="myBtn px-3 py-2-5 rounded-pill ms-4 text-white" style={{ border: '1px solid #f80'}}>Log in</Link>
          </div>
        </div> 
      </div>*/}
      {/* <section style={{paddingBottom: '8rem'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="d-flex flex-column align-items-center">
                <img src={require('../images/analyst.png')} alt="Analytics" style={{width: '100px'}}/>
                <h4 className="fw-bold mt-4 mb-2" style={{color: '#f80'}}>Analytics</h4>
                <p className="text-center mb-0">Our platform delivers insightful analytics and strategic guidance, enabling you to optimize your financial decisions and achieve your financial objectives</p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="d-flex flex-column align-items-center">
                <img src={require('../images/portfolio.png')} alt="Diverse portfolio" style={{width: '100px'}}/>
                <h4 className="fw-bold mt-4 mb-2" style={{color: '#f80'}}>Diverse portfolio</h4>
                <p className="text-center mb-0">Utilize our platform to safeguard a substantial portfolio of assets, ensuring secure management and protection tailored to your individual needs.</p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="d-flex flex-column align-items-center">
                <img src={require('../images/support.png')} alt="Live support" style={{width: '100px'}}/>
                <h4 className="fw-bold mt-4 mb-2" style={{color: '#f80'}}>Live support</h4>
                <p className="text-center mb-0">Our dedicated team of knowledgeable representatives is always ready to assist you with any concerns, or support you may need at any time of day. </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '8rem'}}>
        <div className="container">
          <h1 className="tex-white fw-bold mb-5 pb-5">Trusted by thousands of <br/> users worldwide</h1>
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">$100M+</h1>
                <p className="mb-0">Paid out to traders</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">180+</h1>
                <p className="mb-0">Countries registered with us</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">13M+</h1>
                <p className="mb-0">Volume of trades monthly</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">3h</h1>
                <p className="mb-0">Avg. payout processing time</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <h1 className="mb-3 text-center text-black">All your financial assets in one place</h1>
          <p className="mb-5 text-center text-dark">Get a stock account, foreign exchange broker and cryptocurrency exchange -in one refreshingly easy solution.</p>
          <img src={require('../images/markets.570e8cb2e10e06736455.png')} alt="Diverse portfolio" style={{width: '100%'}}/>
        </div>
      </section> */}
      <div className="bgd-home">
      <FrontHeader/>
      <HeroSection />  
      </div>
      <DashboardBanner />
      {/* <CryptoWiget /> */}
      <CryptoJourney/>
      <SectionBody/>
      <ProductsSection/>
      <DownloadApp />
      <section style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <p className="mb-0 text-center mb-2">RESELLTRADEMARKET CAMPUSES</p>
          <h1 className="mb-0 text-center fw-bold">10+ WEALTH CREATION METHODS</h1>
          <div className="row mt-5">
            <div className="col-lg-4 col-12">
              <div style={{backgroundColor: '#09141b'}}>
                <div className="p-3">
                  <img src={require('../images/RWContent.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>CRYPTO STAKING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Earn passive income by staking your crypto. Lock your coins to support blockchain networks and receive regular rewards. Learn how to start staking and make your digital assets work for you.</p>
                </div>
                <img src={require('../images/RWContentCreation.jpg')} alt="photo" style={{width: '100%'}}/>
                <div className="p-3">
                  <img src={require('../images/RWCopy.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>COPYWRITING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Words are your warriors, and every sentence is a strategy. Master the craft of copywriting with us, and you'll learn to turn prose into profit.</p>
                </div>
                <img src={require('../images/RWCopywriting.jpg')} alt="photo" style={{width: '100%'}}/>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div style={{backgroundColor: '#09141b'}}>
                <div className="p-3">
                  <img src={require('../images/RWCoin.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>CRYPTO INVESTING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>The Bull Run is making its rounds again early 2024. You need to be equipped. We cut through the complexity and get you to the core of crypto, where strategic investments meet swift returns.</p>
                </div>
                <img src={require('../images/RWCryptoInvesting.jpg')} alt="photo" style={{width: '100%'}}/>
                <div className="p-3">
                  <img src={require('../images/RWShop.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>AMAZON FBA</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Imagine launching a store overnight and tapping into the global marketplace by morning. E-Commerce is your gateway to rapid retail success.</p>
                </div>
                <img src={require('../images/RWEcommerce.jpg')} alt="photo" style={{width: '100%'}}/>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div style={{backgroundColor: '#09141b'}}>
                <div className="p-3">
                  <img src={require('../images/RWCoin.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>CRYPTO TRADING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Take advantage of the bull run and master the art of crypto trading in the Crypto Trading campus, where we empower you to navigate the markets with precision.</p>
                </div>
                <img src={require('../images/RWCryptoTrading.jpg')} alt="photo" style={{width: '100%'}}/>
                <div className="p-3">
                  <img src={require('../images/RWBusiness.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>BUSINESS</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>The Real World's business training is about mastering the art of leadership and scaling operations.</p>
                </div>
                <img src={require('../images/RWBusiness.jpg')} alt="photo" style={{width: '100%'}}/>
              </div>
            </div>
          </div>
          <p className="mb-0 text-center mb-2 mt-5 pt-5">A STEP-BY-STEP PATH</p>
          <h1 className="mb-0 text-center fw-bold">TOOLS TO MAXIMISE YOUR INCOME</h1>
          <div className="row mt-5">
            <div className="col-md-6">
              <img src={require('../images/RWPhone.webp')} alt="Diverse portfolio" style={{width: '100%'}}/>
            </div>
            <div className="col-md-6">
              <div className="d-flex align-items-center mb-4">
                <FontAwesomeIcon icon={faGraduationCap} className="me-2" style={{fontSize: '24px'}} />
                <h3 className="mb-0 fw-bold text-white">VITAL LIFE LESSONS</h3>
              </div>
              <div className="rw-li mb-3">
                <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>World-class custom built learning application</h5>
              </div>
              <div className="rw-li mb-3">
                <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Scale from Zero to $10k/month as fast as possible</h5>
              </div>
              <div className="rw-li mb-3">
                <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Master skills you need to maximize your income</h5>
              </div>
            </div>
            <div className="col-md-6">
              <img src={require('../images/RWPrivate.webp')} alt="Diverse portfolio" style={{width: '100%'}}/>
            </div>
            <div className="col-md-6">
              <div>
                <div className="d-flex align-items-center mb-4">
                  <FontAwesomeIcon icon={faGraduationCap} className="me-2" style={{fontSize: '24px'}} />
                  <h3 className="mb-0 fw-bold text-white">PRIVATE NETWORK</h3>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Celebrate your wins with people who understand</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Make like-minded friends on your journey</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Network with 113,000+ students</h5>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <img src={require('../images/RWAccess.webp')} alt="Diverse portfolio" style={{width: '100%'}}/>
            </div>
            <div className="col-md-6">
              <div>
                <div className="d-flex align-items-center mb-4">
                  <FontAwesomeIcon icon={faGraduationCap} className="me-2" style={{fontSize: '24px'}} />
                  <h3 className="mb-0 fw-bold text-white">ACCESS TO MULTIMILLIONAIRES</h3>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Mentors are hyper-successful experts in their field</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Get mentored every step of your journey</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>1-on-1 advice from industry experts</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-2 mt-4">
            <Link to="/register" className="myBtn bg-prime px-4 py-2-5 rounded-5">JOIN THE REAL WORLD</Link>
          </div>
          <p className="mb-0 text-center fw-semibold"><FontAwesomeIcon icon={faLayerGroup} className="me-1" style={{fontSize: '16px'}} />Access 12+ wealth creation methods</p>
          <h1 className="mb-0 text-center fw-bold mt-5 pt-5 mb-4">Get started with trading today</h1>
          <p className="text-center mx-auto mb-4" style={{maxWidth: '36rem'}}>It’s easy to get started. Register an account with us and get started with trading today.</p>
          <div className="d-flex justify-content-center">
            <Link to="/register" className="myBtn bg-prime px-4 py-2-5 rounded-5">Get started</Link>
          </div>
        </div>
      </section>
      <FrontFooter/>
    </div>
  )
}

export default Home